/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSectorCommand } from '../../models/create-sector-command';
import { CreateSectorCommandResult } from '../../models/create-sector-command-result';

export interface ApiSectorCreateSectorPost$Params {
      body?: CreateSectorCommand
}

export function apiSectorCreateSectorPost(http: HttpClient, rootUrl: string, params?: ApiSectorCreateSectorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSectorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorCreateSectorPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSectorCommandResult>;
    })
  );
}

apiSectorCreateSectorPost.PATH = '/api/Sector/CreateSector';
